// Standalone Textarea. For textareas with adornments (icons, buttons, prefix/suffix text),
// compose with InputGroup (via InputGroupTextarea) instead of extending this component.
import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const textareaVariants = cva(
  'flex field-sizing-content w-full rounded-lg border border-neutral-ui-border bg-app ' +
    'text-primary-high-contrast placeholder:text-text-body ' +
    'selection:bg-primary selection:text-primary-foreground ' +
    'transition-[color,box-shadow,border-color] outline-none ' +
    'hover:border-neutral-hover-border ' +
    'focus-visible:border-2 focus-visible:border-primary-ui-border ' +
    'aria-invalid:border-destructive aria-invalid:bg-error-app-bg aria-invalid:text-error-solid ' +
    'disabled:bg-neutral-subtle-bg disabled:border-neutral-subtle-border disabled:text-neutral-low-contrast disabled:opacity-60 disabled:cursor-not-allowed disabled:pointer-events-none',
  {
    variants: {
      size: {
        sm: 'min-h-[60px] px-2 py-1 text-xs',
        default: 'min-h-[80px] px-3 py-2 text-sm',
        lg: 'min-h-[100px] px-4 py-3 text-base',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)

function Textarea({
  className,
  size,
  ...props
}: Omit<React.ComponentProps<'textarea'>, 'size'> &
  VariantProps<typeof textareaVariants>) {
  return (
    <textarea
      data-slot="textarea"
      data-size={size ?? 'default'}
      className={cn(textareaVariants({ size }), className)}
      {...props}
    />
  )
}

export { Textarea, textareaVariants }
